import React, { useState, useEffect } from 'react';

const usePagination = (pageData, itemsPerPage) => {
  const [data, setData] = useState(pageData || null);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    let itemOffsetVal = itemOffset;

    const endOffset = itemOffsetVal + itemsPerPage;

    setCurrentItems(data.slice(itemOffsetVal, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [data, itemOffset, itemsPerPage])

  const onPageClick = (pageNum) => {
    let d = data;

    const newOffset = ((pageNum - 1) * itemsPerPage) % d.length;

    setItemOffset(newOffset);
    setActivePage(pageNum);
  };

  return [activePage, pageCount, currentItems, onPageClick, setData];
}

export default usePagination;